import {
  Directive,
  forwardRef,
  OnInit,
  inject,
  DestroyRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Ag1ChipComponent } from '../components/ag1-chip/ag1-chip.component';
import {
  outputToObservable,
  takeUntilDestroyed,
} from '@angular/core/rxjs-interop';

@Directive({
  selector: 'ag1-chip',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Ag1ChipValueAccessorDirective),
      multi: true,
    },
  ],
})
export class Ag1ChipValueAccessorDirective
  implements ControlValueAccessor, OnInit
{
  private _destroyRef = inject(DestroyRef);
  private _host = inject(Ag1ChipComponent);

  constructor() {}

  private onChange: (value: string[]) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit(): void {
    outputToObservable(this._host.chipsChange)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((chips: string[]) => {
        this.onChange(chips);
      });
  }

  writeValue(value: string[]): void {
    if (value) {
      this._host.chips = value;
    }
  }

  registerOnChange(fn: (value: string[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Handle the disabled state if necessary
  }
}
